"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var modal_1 = __importDefault(require("../../../plugins/modal"));
exports.default = (function (_a) {
    var isOpen = _a.isOpen;
    return (react_1.default.createElement(modal_1.default, { disableClose: true, isOpen: isOpen },
        react_1.default.createElement("div", { className: 'padding-horizontal-4 padding-top-8 padding-bottom-4 text-center' },
            react_1.default.createElement("h3", { className: 'h4' }, "Your order is on the way!"),
            react_1.default.createElement("div", { className: 'font-lighter margin-vertical-4' }, "Click the button below to manage your next month's bundle."),
            react_1.default.createElement("a", { href: '/account', className: 'button wisteria width-100', style: { fontSize: '22px' } }, "My Account"))));
});
